<template>
  <div class="container spacing">
    <h1 class="headline-subprimary text--center">
      <span class="text--blue text--script">{{ this.$i18n.t('LANDING.HEADER1') }}</span>{{ this.$i18n.t('LANDING.HEADER2') }}
    </h1>
    <br>
    <p style="text-align: center;">
      {{ this.$i18n.t('LANDING.SUBHEADER') }}
    </p>
    <narrow-container>
      <div class="img-container">
        <img
          v-if="!ismobileWidth"
          src="@/assets/image/Landing_Black.svg"
        >
      </div>
    </narrow-container>
    <div
      v-if="ismobileWidth"
    >
      <landing-page-image
        id="aufrubbeln"
        name="aufrubbeln"
        :img="aufrubbeln"
        :caption="this.$i18n.t('LANDING.ACTIVATION')"
      />
      <landing-page-image
        id="zahlungsmethode"
        name="zahlungsmethode"
        :img="zahlungsmethode"
        :caption="this.$i18n.t('LANDING.PAYMENT_METHOD')"
      />
      <landing-page-image
        id="downloaden"
        name="downloaden"
        :img="downloaden"
        :caption="this.$i18n.t('LANDING.DOWNLOAD')"
      />
      <landing-page-image
        id="fernsehen"
        name="fernsehen"
        :img="fernsehen"
        :caption="this.$i18n.t('LANDING.WATCH_TV')"
      />
    </div>
    <br>
    <teaser
      id="Aktivierung"
      name="Aktivierung"
      url="#/activation"
      :img="aktivierungWide"
      :img-mobile="aktivierungTall"
      :caption="this.$i18n.t('LANDING.ACTIVATE_CAPTION')"
      :button-label="this.$i18n.t('LANDING.ACTIVATE_BUTTON')"
    >
      {{ this.$i18n.t('LANDING.ACTIVATE_HEADER') }}
    </teaser>
    <teaser
      id="Anmeldung"
      name="Anmeldung"
      url="#/login"
      :img="anmeldungWide"
      :img-mobile="anmeldungTall"
      :caption="this.$i18n.t('LANDING.LOGIN_CAPTION')"
      :button-label="this.$i18n.t('LANDING.LOGIN_BUTTON')"
      :invert="true"
    >
      {{ this.$i18n.t('LANDING.LOGIN_HEADER') }}
    </teaser>
    <teaser
      id="atu"
      name="atu"
      url="#/protected/topup"
      :img="atuWide"
      :img-mobile="atuTall"
      :caption="this.$i18n.t('LANDING.ATU_CAPTION')"
      :button-label="this.$i18n.t('LANDING.ATU_BUTTON')"
      :invert="false"
    >
      {{ this.$i18n.t('LANDING.AUTOMATIC') }}
    </teaser>
    <teaser
      id="dreitv"
      name="dreitv"
      url="/n/shops/s?EmpfohleneStandorte=Drei+Shops+%26+Drei+BestPartner+Gold"
      :img="dreitvWide"
      :img-mobile="dreitvTall"
      :caption="this.$i18n.t('LANDING.DREITV_CAPTION')"
      :button-label="this.$i18n.t('LANDING.DREITV_BUTTON')"
      :invert="true"
    >
      {{ this.$i18n.t('LANDING.DREITV_HEADER') }}
    </teaser>
    <teaser
      id="Info"
      name="Info"
      url="https://www.drei.at/de/privat/produkte-und-services/drei-tv/vorteile-und-funktionen.html"
      :img="infoWide"
      :img-mobile="infoTall"
      :caption="this.$i18n.t('LANDING.INFO_CAPTION')"
      :button-label="this.$i18n.t('LANDING.INFO_BUTTON')"
      :invert="false"
    >
      {{ this.$i18n.t('LANDING.INFO_HEADER') }}
    </teaser>
  </div>
</template>

<script>
import LandingPageImage from '@/components/teaser/LandingPageImage.vue';
import Teaser from '@/components/teaser/Teaser.vue';


const breakingWidth = 500;

export default {
  name: 'Landing',
  components: { LandingPageImage, Teaser },
  data: function() {
    return {
      width: 0,
      anmeldungTall: require('@/assets/image/Anmeldung_tall.jpg'),
      anmeldungWide: require('@/assets/image/Anmeldung_wide.jpg'),
      aktivierungTall: require('@/assets/image/Aktivierung_tall.jpg'),
      aktivierungWide: require('@/assets/image/Aktivierung_wide.jpg'),
      infoTall: require('@/assets/image/Info_tall.jpg'),
      infoWide: require('@/assets/image/Info_wide.jpg'),
      aufrubbeln: require('@/assets/image/Aufrubbeln_Black.png'),
      zahlungsmethode: require('@/assets/image/Zahlungsmethode_Black.png'),
      downloaden: require('@/assets/image/App_Downloaden_Black.png'),
      fernsehen: require('@/assets/image/Fernsehen_Black.png'),
      atuWide: require('@/assets/image/Atu.jpg'),
      atuTall: require('@/assets/image/Atu.jpg'),
      dreitvTall: require('@/assets/image/Dreitv_tall.png'),
      dreitvWide: require('@/assets/image/Dreitv_wide.jpg')
    };
  },
  computed: {
    ismobileWidth: function() {
      return this.width <= breakingWidth;
    }
  },
  created: function() {
    window.addEventListener('resize', this.handleWindowResize);
    window.addEventListener('orientationchange', this.handleWindowResize);
    this.handleWindowResize()
  },
  destroyed: function() {
    window.removeEventListener('resize', this.handleWindowResize);
    window.removeEventListener('orientationchange', this.handleWindowResize);
  },
  methods: {
    handleWindowResize: function() {
      this.width = document.documentElement.clientWidth;
    }
  },
};
</script>

<style lang="scss" src="@/components/img.scss">
</style>

<style lang="scss" src="@/views/landing/header-just-for-this-spot.scss">
</style>
